import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const positionsSlice = createSlice({
  name: "positions",
  initialState,
  reducers: {
    setPositions(state, action) {
      state.data = action.payload;
    },
    addPosition(state, action) {
      state.data.unshift(action.payload);
    },
    closePosition(state, action) {
      // Use filter to remove closed positions
      state.data = state.data.filter((pos) => pos.id !== action.payload);
    },
    updatePosition(state, action) {
      const updated = action.payload;
      state.data = state.data.map((pos) =>
        pos.id === updated.id ? { ...pos, ...updated } : pos
      );
    },
    removePosition(state, action) {
      const id = action.payload;
      state.data = state.data.filter((pos) => pos.id !== id);
    },
  },
});

export const {
  setPositions,
  addPosition,
  closePosition,
  updatePosition,
  removePosition,
} = positionsSlice.actions;

export default positionsSlice.reducer;
